export default {
  default: () => import("/opt/atlassian/pipelines/agent/build/public-pages/layouts/default.vue").then(m => m.default || m),
  fundraising: () => import("/opt/atlassian/pipelines/agent/build/public-pages/layouts/fundraising.vue").then(m => m.default || m),
  peer: () => import("/opt/atlassian/pipelines/agent/build/public-pages/layouts/peer.vue").then(m => m.default || m)
}